import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { OFFER_INCLUDES, PRODUCT_NAME } from './salesData';
import { BUNDLE_IMAGE_URL } from '../utils/headMeta';

/** La oferta completa: todo lo que entra, el precio y el botón de compra. */
export function OfferSection() {
  return <section id="comprar" className="warm-halo w-full border-b border-line" data-id="element-133" data-mp="idzwv6fp9c5b">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20" data-id="element-134" data-mp="metni7kj151w">
        <div className="max-w-2xl" data-id="element-135" data-mp="mgwkjbk3jyg4">
          <SectionTag data-id="element-136" data-mp="re696oznw62w">La oferta completa</SectionTag>
          <h2 className="mt-4 font-condensed text-[2.1rem] uppercase leading-[0.95] text-bone sm:text-5xl" data-id="element-137" data-mp="repodxxxggd8">
            Todo lo que te llevás hoy
          </h2>
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl border border-gold/30 bg-carbon-soft" data-id="element-138" data-mp="2t6b3u88jphhb">
          <div className="grid lg:grid-cols-[0.95fr_1.05fr]" data-id="element-139" data-mp="2y5fhpc6f03dz">
            {/* Mockup */}
            <div className="flex items-center justify-center border-b border-line bg-ink/70 p-7 sm:p-10 lg:border-b-0 lg:border-r" data-id="element-140" data-mp="12ns6pivrp13x">
              <img src={BUNDLE_IMAGE_URL} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos exclusivos`} loading="lazy" decoding="async" className="w-full max-w-[420px] rounded-xl shadow-[0_36px_100px_-50px_rgba(255,196,0,0.55)]" data-id="element-141" data-mp="xvh2i3tzut5k" />
            </div>

            {/* Detalle */}
            <div className="p-7 sm:p-10" data-id="element-142" data-mp="1gocnyam1aovb">
              <h3 className="font-condensed text-3xl uppercase leading-none text-bone sm:text-4xl" data-id="element-143" data-mp="1glgo2gqmlq48">
                {PRODUCT_NAME}
              </h3>

              <ul className="mt-6 space-y-3" data-id="element-144" data-mp="17ljv42x7e53d">
                {OFFER_INCLUDES.map(item => <li key={item} className="flex items-center gap-3 font-display text-[1.02rem] leading-snug text-bone" data-id="element-145" data-mp="17kjksb33lr6">
                    <CheckIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-146" data-mp="3tthogr91uy69" />
                    {item}
                  </li>)}
              </ul>

              <div className="mt-8 border-t border-line pt-7" data-id="element-147" data-mp="3kvnqlbvmzwgz">
                <PriceBlock size="lg" data-id="element-148" data-mp="3otbqktc6sffq" />
                <div className="mt-6" data-id="element-149" data-mp="3b3i1qb0olv60">
                  <CTAButton data-id="element-150" data-mp="3b2gqa5fr76nr" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}